import Relay from 'react-relay';

class RemoveGroupMemberMutation extends Relay.Mutation {
  getMutation = () => Relay.QL`mutation {removeGroupMembers}`;

  getVariables() {
    const members = [{
      id: this.props.contacts.contact.id,
      type: 'Contact',
    }];
    return {
      // id of the fav group no need to specify
      members,
    };
  }
  getFatQuery() {
    return Relay.QL`
      fragment on RemoveGroupMembersPayload {
        removedContacts {
          isFavorite
        }
      }
    `;
  }
  getConfigs() {
    return [{
      type: 'REQUIRED_CHILDREN',
      children: [Relay.QL`
        fragment on RemoveGroupMembersPayload {
          removedContacts {
            isFavorite
          }
        }
      `],
    }];
  }
}

export default RemoveGroupMemberMutation;



// WEBPACK FOOTER //
// ./src/js/Mutations/RemoveGroupMemberMutation.js